require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-501-vr-development-with-unity.json") })
        }
      }, "path---courses-code-501-vr-development-with-unity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-501-vr-development-with-unity!./.cache/json/courses-code-501-vr-development-with-unity.json
// module id = 1204
// module chunks = 231608221292675